var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3898 40.71C21.7598 40.77 22.1398 40.81 22.5198 40.84C22.1398 40.81 21.7698 40.77 21.3898 40.71ZM23.9998 7.09002C14.6598 7.09002 7.08984 14.66 7.08984 24C7.08984 32.44 13.2698 39.44 21.3598 40.7V28.88H17.0598V23.99H21.3598V20.26C21.3598 16.02 23.8898 13.68 27.7498 13.68C29.5998 13.68 31.5398 14.01 31.5398 14.01V18.17H29.4098C27.3098 18.17 26.6498 19.48 26.6498 20.81V23.98H31.3398L30.5898 28.87H26.6498V40.69C34.7298 39.42 40.9198 32.43 40.9198 23.99C40.9198 14.65 33.3498 7.08002 24.0098 7.08002L23.9998 7.09002ZM26.6098 40.71C26.2298 40.77 25.8498 40.81 25.4598 40.84C25.8498 40.81 26.2298 40.76 26.6098 40.71Z",
    fill: "#1977F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.dc98220f8e2d6638bf79549a737be191.svg";
export { ForwardRef as ReactComponent };